// Reusable download badges. Apple = active link, Google Play = coming soon.
import { trackEvent } from "../lib/analytics";

const APP_STORE_URL = "#"; // Replace with live App Store URL once approved

export function AppStoreButton({ variant = "dark", testId = "btn-appstore" }) {
    const bg = variant === "dark" ? "bg-[#2D2D2D]" : "bg-white";
    const text = variant === "dark" ? "text-white" : "text-[#2D2D2D]";
    const border =
        variant === "dark" ? "border-[#2D2D2D]" : "border-[#E5D7C5]";

    return (
        <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={testId}
            onClick={() => trackEvent("download_click", window.location.pathname)}
            className={`group inline-flex items-center gap-3 px-5 py-3 rounded-2xl ${bg} ${text} border ${border} shadow-soft hover:shadow-lift hover:-translate-y-0.5 transition-all duration-300`}
        >
            <svg
                aria-hidden="true"
                viewBox="0 0 384 512"
                className="w-7 h-7 fill-current"
            >
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zM255.5 80.2c30.5-36.2 27.7-69.2 26.8-81.2-27 1.6-58.2 18.4-76 39.1-19.6 22.2-31.1 49.7-28.6 80.5 29.2 2.3 55.9-12.7 77.8-38.4z" />
            </svg>
            <span className="flex flex-col leading-tight text-left">
                <span className="text-[10px] uppercase tracking-widest opacity-80">
                    Download on the
                </span>
                <span className="text-base font-semibold font-sans">
                    App Store
                </span>
            </span>
        </a>
    );
}

const GooglePlaySvg = () => (
    <svg
        aria-hidden="true"
        viewBox="0 0 512 512"
        className="w-7 h-7 opacity-70"
    >
        <path
            d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1z"
            fill="#EA4335"
        />
        <path
            d="M104.6 13C97.4 16.3 92 22.8 92 32v448c0 9.2 5.4 15.7 12.6 19l215.2-215.2L104.6 13z"
            fill="#FBBC04"
        />
        <path
            d="M385.4 337.8l-64.6-37-65.3 65.4 129.9 74.6c18.1 10.4 34.6-4.5 37.5-21.8 2-11.6-37.5-81.2-37.5-81.2z"
            fill="#34A853"
        />
        <path
            d="M104.6 499c1.3.6 2.7.9 4.2.9 5.4 0 11.5-2.7 18.8-7l198.8-114L256 308.3 104.6 499z"
            fill="#4285F4"
        />
    </svg>
);

const SoonBadge = ({ variant }) => (
    <span
        className={`absolute -top-2 -right-2 px-2 py-0.5 text-[10px] uppercase tracking-widest font-semibold rounded-full ${
            variant === "dark"
                ? "bg-[#C4956A] text-white"
                : "bg-[#2D2D2D] text-[#FDF6EE]"
        }`}
    >
        Soon
    </span>
);

// Google Play — intentionally rendered as a disabled "Coming soon" badge
// (BookBlend is Apple-only at launch).
export function GooglePlayButton({
    variant = "dark",
    testId = "btn-googleplay",
}) {
    const bg = variant === "dark" ? "bg-[#2D2D2D]/50" : "bg-white/70";
    const text = variant === "dark" ? "text-white/80" : "text-[#6B655C]";
    const border =
        variant === "dark" ? "border-white/10" : "border-[#E5D7C5]";

    return (
        <div
            data-testid={testId}
            aria-disabled="true"
            className={`relative inline-flex items-center gap-3 px-5 py-3 rounded-2xl ${bg} ${text} border ${border} cursor-not-allowed select-none`}
        >
            <GooglePlaySvg />
            <span className="flex flex-col leading-tight text-left">
                <span className="text-[10px] uppercase tracking-widest opacity-80">
                    Coming soon to
                </span>
                <span className="text-base font-semibold font-sans">
                    Google Play
                </span>
            </span>
            <SoonBadge variant={variant} />
        </div>
    );
}
